import { render, staticRenderFns } from "./employee-app.vue?vue&type=template&id=2543cad2"
import script from "./employee-app.vue?vue&type=script&lang=js"
export * from "./employee-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports